var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "transition",
        { attrs: { name: "fade-alert" } },
        [
          _vm.showAlert
            ? _c("el-alert", {
                attrs: {
                  type: _vm.type,
                  title: _vm.title,
                  description: _vm.description,
                  "show-icon": "",
                  closable: _vm.closable
                },
                on: {
                  close: function($event) {
                    _vm.colapsedMode ? _vm.alertVisibility() : ""
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade-icon" } }, [
        _vm.colapsedMode && _vm.showIcon
          ? _c("i", {
              class:
                "el-alert__icon el-icon-" +
                _vm.type +
                " is-big el-alert--" +
                _vm.type +
                " is-light",
              staticStyle: { cursor: "pointer", "border-radius": "50%" },
              attrs: { title: _vm.description },
              on: { click: _vm.alertVisibility }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-580b980a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-580b980a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Alert/Alert.vue
// module id = null
// module chunks = 